// ForgotPassword_new.jsx migration (Phase E). Keys ordered to match the file's own reading order:
// page heading, step 1 (Application ID / Email / Mobile Number entry + Send OTP / Back To Login
// buttons), step 2 (OTP-sent note + Resend OTP link), step 3 (OTP field), then validation/error
// messages in the order they occur (onTextChange, then validateFormData, then validateOTPFormData,
// then the sendOTP catch-all message).
//
// Some field labels this file already shared verbatim with other migrated screens are intentionally
// NOT duplicated here — ForgotPassword_new.jsx keeps using the existing dictionary.js namespaces for
// those instead: passwordCommon.newPasswordLabel, passwordCommon.confirmPasswordLabel,
// passwordCommon.pleaseEnterNewPassword, passwordCommon.pleaseEnterConfirmPassword, and
// resetPassword.submitButton (all exact-text matches already present in dictionary.js).
//
// Every entry below marked "AI-authored, needs linguistic QA" had no existing Marathi anywhere in
// this file; the Marathi authored for those reuses this same file's own existing terminology
// (अर्ज आयडी / ईमेल / मोबाईल क्रमांक / एक वेळ पासवर्ड / पासवर्ड) wherever a matching term already
// appears elsewhere in the file, rather than inventing new vocabulary.
export default {
  // Page heading — English-only in the file today. AI-authored, needs linguistic QA.
  pageHeading: { en: 'Forgot Password', mr: 'पासवर्ड विसरलात' },

  // Step 1: Application ID / Email / Mobile Number entry — all extracted from existing bilingual
  // placeholders/headings in the file (zero new translation authored).
  applicationIdPlaceholder: { en: 'Application ID', mr: 'अर्ज आयडी' },
  applicationIdLabel: { en: 'Application ID', mr: 'अर्ज आयडी' },
  emailPlaceholder: { en: 'Email', mr: 'ईमेल' },
  emailLabel: { en: 'Email', mr: 'ईमेल' },
  mobileNumberPlaceholder: { en: 'Mobile Number', mr: 'मोबाईल क्रमांक' },
  mobileNumberLabel: { en: 'Mobile Number', mr: 'मोबाईल क्रमांक' },
  sendOtpButton: { en: 'Send OTP', mr: 'एक वेळ पासवर्ड पाठवा' },
  backToLoginButton: { en: 'Back To Login Page', mr: 'लॉगिन पृष्ठावर परत जा' },

  // Step 2: OTP-sent note + Resend OTP link — extracted (already bilingual), except noteLabel
  // ("Note: ") which had no existing Marathi anywhere in the file. AI-authored, needs linguistic QA.
  noteLabel: { en: 'Note:', mr: 'टीप:' },
  otpSentNote: {
    en: 'OTP has been sent to your registered email.',
    mr: 'तुमच्या नोंदणीकृत ईमेलवर एक वेळ पासवर्ड पाठवण्यात आला आहे.'
  },
  resendOtpLink: { en: 'Resend OTP', mr: 'पुन्हा एकदा एक वेळ पासवर्ड पाठवा' },

  // Step 3: OTP field — extracted from existing bilingual placeholder/heading.
  otpPlaceholder: { en: 'OTP', mr: 'एक वेळ पासवर्ड' },
  otpLabel: { en: 'OTP', mr: 'एक वेळ पासवर्ड' },

  // Validation / error messages — all English-only in the file today. AI-authored, needs linguistic
  // QA. Marathi reuses this file's own terms for Application ID / Email / Mobile Number / OTP.
  pleaseEnterApplicationId: { en: 'Please Enter Application ID', mr: 'कृपया अर्ज आयडी प्रविष्ट करा' },
  invalidEmail: { en: 'Invalid Email', mr: 'अवैध ईमेल' },
  pleaseEnterEmail: { en: 'Please Enter Email', mr: 'कृपया ईमेल प्रविष्ट करा' },
  pleaseEnterValidMobileNumber: {
    en: 'Please Enter Valid Mobile Number',
    mr: 'कृपया वैध मोबाईल क्रमांक प्रविष्ट करा'
  },
  pleaseEnterMobileNumber: { en: 'Please Enter Mobile Number', mr: 'कृपया मोबाईल क्रमांक प्रविष्ट करा' },
  passwordsNotMatched: {
    en: 'New Password and Confirm Password not matched',
    mr: 'नवीन पासवर्ड आणि पासवर्डची पुष्टी जुळत नाहीत'
  },
  pleaseEnterValidOtp: { en: 'Please Enter Valid OTP', mr: 'कृपया वैध एक वेळ पासवर्ड प्रविष्ट करा' },
  pleaseEnterOtp: { en: 'Please Enter OTP', mr: 'कृपया एक वेळ पासवर्ड प्रविष्ट करा' },
  invalidUserInfo: {
    en: 'Invalid user, Please provide proper information',
    mr: 'अवैध वापरकर्ता, कृपया योग्य माहिती द्या'
  }
};
